
import React, { useEffect, useRef, useState } from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Table,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Progress,
    Input,
    UncontrolledDropdown,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';

import { db } from '../MY_LOGIN_AND_SIGNUP/db/config';
import NotificationAlert from 'react-notification-alert';
import firebase, { auth } from 'firebase';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import algoliasearch from 'algoliasearch/lite';
import { algoliaAppID, algoliaSearchID } from '../Utilities/algoliaKeys';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddMaterialStudent from 'STUDENT_MODULE/AddMaterialStudent';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

function BatchStudent() {
const navigate = useNavigate()
    const [limit, setLimit] = useState(10);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [packageInfo, setPackageInfo] = React.useState(null);
    const location = useLocation();
    const {batchName,batchId} = location?.state||{};
    const handleClose = () => {
        setFilter(0);
        setAnchorEl(null);
    };

    const [progressVisible, setProgressVisible] = useState(true);
    const [progressValue, setProgressValue] = useState(8);
    const [userData, setUserData] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [startIndex, setStartIndex] = useState(1);
    const [endIndex, setEndIndex] = useState(0);
    const [filter, setFilter] = useState(0);
    const [fullDialogOpen, setFullDialogOpen] = useState(false);
    const [currentStuId, setcurrentStuId] = useState('');
    const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
    const [sortByErollment, setSortByErollment] = useState(false);

    const [viewVisible, setViewVisible] = useState(false);
    const [currentUser, setCurrentUser] = useState({});

    const [packages, setPackages] = useState([]);

    const [selectedbranch, setSelectedBranch] = useState('');

    const handlefullToggle = () => {
        setFullDialogOpen((prev) => !prev);
    };

    const notifi = useRef();
    const notify = (msg, err) => {
        // console.log('notify')
        let color = err == false ? 'success' : 'danger';
        let options = {
            type: color,
            place: 'tr',
            message: (
                <div>
                    <div>
                        <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
                    </div>
                </div>
            ),
            icon: 'tim-icons icon-bell-55',
            autoDismiss: 6,
        };
        if (notifi.current) {
            notifi.current.notificationAlert(options);
        }
        // notification(options);
    };
    const getUsers = (orderBy) => {
        setProgressValue(99);
        document.querySelector('#loading-indicator').style.display = 'flex';


        db.collection('zSystemStudents')
            .where('batch', 'array-contains', batchId)
            .orderBy('createdAt', 'desc')
            .get()
            .then(function (querySnapshot) {
                var students = [];
                querySnapshot.docs.forEach(function (doc) {
                    students.push(doc.data());
                });
                students = students.map((item) => {
                    return { ...item, select: false };
                });
                document.querySelector('#loading-indicator').style.display = 'none';
                // downloadUserData()
                setUserData(students);
                setProgressVisible(false);
                setStartIndex(1);
                setEndIndex(students.length);
            });
    };

    const getBatch = () => {
        db.collection('Batch')
            .where('type', '==', 'batch')
            .get()
            .then((querySnapshot) => {
                let data = querySnapshot.docs.map((doc) => doc.data());
                setBatchList(data);
            });
    };

    const getCurrentUser = () => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                db.collection('zSystemUsers')
                    .doc(user.uid)
                    .get()
                    .then((query) => {
                        let data = query.data();
                        console.log('currentuserData', data);
                        setCurrentUser(data);
                    });
            }
        });
    };

    useEffect(() => {
        console.log(location,batchId,batchName,'isCheckLocation');
        getBatch();
        getPackages();
        getCurrentUser();
    }, []);

    useEffect(() => {
        if (sortByErollment) {
            getUsers(sortByErollment);
            return;
        }
        getUsers();
    }, [limit]);

    useEffect(() => {
        if (viewVisible && !packageInfo) {
            db.collection('zSystemStore')
                .get()
                .then((querySnapshot) => {
                    let data = querySnapshot.docs.map((doc) => doc.data());
                    let finalData = {};
                    data = data.map((item) => ({
                        itemID: [item.itemID],
                        title: item?.title,
                    }));
                    for (var i = 0; i < data.length; i++) {
                        finalData[data[i].itemID] = data[i].title;
                    }
                    setPackageInfo(finalData);
                });
        }
    }, [viewVisible]);

    const getPackages = () => {
        db.collection('zSystemStore')
            .where('type', '==', 'package')
            .where('withClasses', '==', true)
            .get()
            .then((query) => {
                let data = query.docs.map((doc) => doc.data());
                setPackages(data);
            });
    };
    

    console.log('currentUser', currentUser);

    return (
        <>
            {progressVisible ? (
                <Progress color='info' value={progressValue} style={{ height: 4 }} />
            ) : (
                <div className='content'>
                    <div className='react-notification-alert-container'>
                        <NotificationAlert ref={notifi} />
                    </div>
                    <Dialog
                        fullScreen
                        open={fullDialogOpen}
                        onClose={handlefullToggle}
                        TransitionComponent={Transition}
                    >
                        <AddMaterialStudent
                            notifi={notify}
                            currentStuId={currentStuId}
                            handleClose={handlefullToggle}
                        />
                    </Dialog>
                    <Row>
                        <Col md='12'>
                            <Card>
                                <CardHeader
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <CardTitle
                                        tag='h4'
                                        style={{
                                            marginRight: 'auto',
                                            fontWeight: 300,
                                            textAlign: 'left',
                                        }}
                                    >
                                            <button
                                                onClick={() => navigate(-1)}
                                                style={{
                                                    marginRight: '5px',
                                                    color: 'white',
                                                    border: '0',
                                                    padding: '0 ',
                                                    outline: 'none',
                                                    background: 'transparent',
                                                    cursor: 'pointer',
                                                    marginBottom: '14px'
                                                }}
                                            >
                                                <KeyboardBackspaceIcon style={{ fontSize: '35px', marginRight: '12px' }} />
                                            </button>
                                        {batchName}
                                    </CardTitle>
                          
                                </CardHeader>
                                <CardBody style={{ paddingTop: '10px' }}>
                                    {selectedbranch.length > 0 && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <span style={{ color: 'yellowgreen', fontSize: '18px' }}>
                                                {selectedbranch}
                                            </span>
                                            <span
                                                style={{
                                                    color: 'yellowgreen',
                                                    fontSize: '18px',
                                                    marginLeft: '8px',
                                                }}
                                            >
                                                {' '}
                                                Branch Results Are Showing...
                                            </span>
                                            <div
                                                style={{
                                                    background: 'orange',
                                                    color: 'white',
                                                    paddingLeft: '5px',
                                                    paddingRight: '5px',
                                                    borderRadius: '10px',
                                                    marginLeft: '10px',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => {
                                                    setSelectedBranch('');
                                                    getUsers();
                                                    handleClose();
                                                }}
                                            >
                                                <span>clear</span>
                                            </div>
                                        </div>
                                    )}

                                    <Table className='tablesorter'>
                                        <thead className='text-primary'>
                                            <tr>
                
                                                <th>Student Name</th>
                                                <th style={{ textAlign: 'center' }}>ENROLL.No</th>
                                                {/* <th style={{ textAlign: 'center' }}>Email</th> */}
                                                <th style={{ textAlign: 'center' }}>Study Material</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData.map((user, i) => {
                                                if (
                                                    user.firstname === undefined &&
                                                    user.lastname === undefined
                                                ) {
                                                    return null;
                                                }
                                                return (
                                                    <tr key={user._uniqueID}>
                                                        <td>{user.firstname + ' ' + user.lastname}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            {user.enrollmentNO ? user.enrollmentNO : 'N/A'}
                                                        </td>
                                                        {/* <td style={{ textAlign: 'center' }}>
                                                            {user.email}
                                                        </td> */}
                                                    
                                          
                                                        <td style={{ textAlign: 'center', minWidth: 70 }}>
                                                            <Button
                                                                color='info'
                                                                style={{ paddingLeft: 10, paddingRight: 10 }}
                                                                onClick={() => {
                                                                    setcurrentStuId(user._uniqueID);
                                                                    handlefullToggle();
                                                                }}
                                                            >
                                                                <LibraryBooksIcon /> / <QuestionAnswerIcon />
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            )}
        </>
    );
}

export default BatchStudent;
